
import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
   const handleEnrollClick = () => {
    window.location.href = '/#home';
  };

  useEffect(() => {
    // Fix all anchor links on the page
    const fixAnchorLinks = () => {
      // Get all anchor links
      const anchors = document.querySelectorAll('a[href^="#"]');
      
      anchors.forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const hash = anchor.getAttribute('href');
          // Navigate to homepage with the hash
          window.location.href = '/' + hash;
        });
      });
    };

    // Run after a short delay to ensure DOM is loaded
    setTimeout(fixAnchorLinks, 100);
    
    // Also fix any dynamically added links
    const observer = new MutationObserver(fixAnchorLinks);
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => observer.disconnect();
  }, []);

  return (
    <div className="privacy-page">
      <Header onEnrollClick={handleEnrollClick} />
      
      <main className="privacy-main">
        <div className="privacy-container" style={{marginTop : '50PX'}}>
          {/* Header */}
          <header className="privacy-header">
            <h1>Privacy Policy</h1>
            <div className="meta-info">
              <p><strong>Effective Date:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
              <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            </div>
          </header>

          {/* Content */}
          <div className="privacy-content">
            
            <section className="privacy-section">
              <h2>1. Introduction</h2>
              <p>
                DYLORA ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and enroll in our 1+1 Internship Program.
              </p>
              <p>
                By using our services, you agree to the collection and use of information in accordance with this policy.
              </p>
            </section>

            <section className="privacy-section">
              <h2>2. Information We Collect</h2>
              
              <h3>2.1 Personal Information</h3>
              <ul>
                <li>Full Name</li>
                <li>Email Address</li>
                <li>Phone Number</li>
                <li>Residential Address</li>
                <li>College/University Name</li>
              </ul>

              <h3>2.2 Academic Information</h3>
              <ul>
                <li>Educational Stream (CS, IT, DSDA, BA, BCOM, BFM, BMMC)</li>
                <li>Year of Passing</li>
                <li>Area of Interest/Tech Domain</li>
              </ul>

              <h3>2.3 Technical Information</h3>
              <ul>
                <li>IP Address</li>
                <li>Browser Type</li>
                <li>Device Information</li>
                <li>Usage Data</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>3. How We Use Your Information</h2>
              
              <div className="usage-table">
                <div className="table-header">
                  <div className="col-purpose">Purpose</div>
                  <div className="col-description">Description</div>
                </div>
                
                <div className="table-row">
                  <div className="col-purpose">Program Enrollment</div>
                  <div className="col-description">To register and manage your participation in the internship program</div>
                </div>
                
                <div className="table-row">
                  <div className="col-purpose">Communication</div>
                  <div className="col-description">To send program updates, schedules, and important announcements</div>
                </div>
                
                <div className="table-row">
                  <div className="col-purpose">Payment Processing</div>
                  <div className="col-description">To facilitate program fee payment through WhatsApp communication</div>
                </div>
                
                <div className="table-row">
                  <div className="col-purpose">Certificate Issuance</div>
                  <div className="col-description">To generate and deliver training and internship certificates</div>
                </div>
                
                <div className="table-row">
                  <div className="col-purpose">Support Services</div>
                  <div className="col-description">To provide customer support and address your queries</div>
                </div>
                
                <div className="table-row">
                  <div className="col-purpose">Program Improvement</div>
                  <div className="col-description">To analyze trends and improve our services</div>
                </div>
              </div>
            </section>

            <section className="privacy-section">
              <h2>4. Data Protection & Security</h2>
              
              <h3>4.1 Security Measures</h3>
              <p>We implement appropriate security measures including:</p>
              <ul>
                <li>Secure database storage with encryption</li>
                <li>Restricted access to personal data</li>
                <li>Regular security audits</li>
                <li>Secure communication channels</li>
              </ul>

              <h3>4.2 Data Retention</h3>
              <p>We retain your personal information only for as long as necessary to:</p>
              <ul>
                <li>Provide our services to you</li>
                <li>Comply with legal obligations</li>
                <li>Resolve disputes</li>
                <li>Enforce our agreements</li>
              </ul>
              <p>Typically, we retain enrollment data for 3 years after program completion.</p>
            </section>

            <section className="privacy-section">
              <h2>5. Third-Party Disclosures</h2>
              <p>We do not sell, trade, or rent your personal information to third parties. However, we may share information with:</p>
              
              <h3>5.1 Service Providers</h3>
              <ul>
                <li>Email service providers for communication</li>
                <li>Database hosting services</li>
                <li>Analytics providers (anonymous data only)</li>
              </ul>

              <h3>5.2 Legal Requirements</h3>
              <p>We may disclose your information if required by law or in response to valid requests by public authorities.</p>
            </section>

            <section className="privacy-section">
              <h2>6. Your Rights</h2>
              
              <div className="rights-grid">
                <div className="right-item">
                  <h3>Right to Access</h3>
                  <p>You can request a copy of the personal data we hold about you.</p>
                </div>
                
                <div className="right-item">
                  <h3>Right to Rectification</h3>
                  <p>You can request correction of inaccurate or incomplete data.</p>
                </div>
                
                <div className="right-item">
                  <h3>Right to Deletion</h3>
                  <p>You can request deletion of your personal data under certain conditions.</p>
                </div>
                
                <div className="right-item">
                  <h3>Right to Object</h3>
                  <p>You can object to the processing of your personal data.</p>
                </div>
              </div>
            </section>

            <section className="privacy-section">
              <h2>7. Cookies & Tracking</h2>
              <p>We use minimal cookies for essential website functionality:</p>
              
              <div className="cookies-table">
                <div className="table-header">
                  <div className="col-cookie">Cookie Type</div>
                  <div className="col-purpose">Purpose</div>
                  <div className="col-duration">Duration</div>
                </div>
                
                <div className="table-row">
                  <div className="col-cookie">Session Cookies</div>
                  <div className="col-purpose">Maintain user session during website navigation</div>
                  <div className="col-duration">Session</div>
                </div>
                
                <div className="table-row">
                  <div className="col-cookie">Preference Cookies</div>
                  <div className="col-purpose">Remember your preferences and settings</div>
                  <div className="col-duration">30 days</div>
                </div>
              </div>
              
              <p className="note">
                <strong>Note:</strong> You can control cookies through your browser settings. Disabling cookies may affect website functionality.
              </p>
            </section>

            <section className="privacy-section">
              <h2>8. WhatsApp Communication</h2>
              <p>As part of our enrollment process:</p>
              <ul>
                <li>We provide a WhatsApp group link for payment instructions and program updates</li>
                <li>WhatsApp communication is subject to WhatsApp's privacy policy</li>
                <li>We do not store WhatsApp chat data in our databases</li>
                <li>You can opt-out of WhatsApp communications at any time</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>9. Children's Privacy</h2>
              <p>Our services are intended for students aged 18 years and above. We do not knowingly collect information from individuals under 18 years of age.</p>
              <p>If you believe we have collected information from a minor, please contact us immediately.</p>
            </section>

            <section className="privacy-section">
              <h2>10. Changes to This Policy</h2>
              <p>We may update this Privacy Policy periodically. We will notify you of any changes by:</p>
              <ul>
                <li>Posting the new Privacy Policy on this page</li>
                <li>Updating the "Last Updated" date</li>
                <li>Sending email notifications for significant changes</li>
              </ul>
              <p>You are advised to review this Privacy Policy periodically for any changes.</p>
            </section>

            <section className="privacy-section">
              <h2>11. Contact Information</h2>
              
              <div className="contact-info">
                <div className="contact-item">
                  <strong>Email:</strong> contact@dylora.in
                </div>
                
                <div className="contact-item">
                  <strong>Phone:</strong> +91 70212 88082
                </div>
                
                <div className="contact-item">
                  <strong>Address:</strong> Chembur, Mumbai, Maharashtra, India
                </div>
                
                <div className="contact-item">
                  <strong>Website:</strong> intern.dylora.in
                </div>
              </div>
              
              <p className="contact-note">
                For privacy-related inquiries or to exercise your rights, please contact us using the information above. 
                We typically respond within 3-5 business days.
              </p>
            </section>

            <section className="privacy-section acknowledgement">
              <h2>Acknowledgement</h2>
              <p>
                By using our website and services, you acknowledge that you have read and understood this Privacy Policy. 
                Your continued use of our services after any modifications to this policy constitutes your acceptance of those changes.
              </p>
              <div className="signature">
                <p><strong>The DYLORA Team</strong></p>
                <p>DYLORA Internship Program</p>
              </div>
            </section>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;